import moment from 'moment-timezone';
import md5 from 'blueimp-md5';
import fetchCollection from './fetchCollection';
import fetchCollection2 from './fetchCollection2';
import indexCollection from './indexCollection';

import { sync } from 'utils/async';

import debug from 'utils/debug';
const D2 = debug('utils:sgerp-api');

const dumpObject = (object) => {
  if (!object) return;

  const newObject = Object.keys(object)
    .sort()
    .reduce((memo, key) => {
      if (key !== 'data') {
        memo[key] = object[key];
      }
      return memo;
    }, {});

  D2.S.C.INFO('O', { newObject });

  // eslint-disable-next-line no-console
  console.log(JSON.stringify(newObject));
};

const fetchObjects = async (api, collection, filter = {}, opts = {}) => {
  const response = await fetchCollection(api, collection, filter, opts);

  if (response?.objects === undefined) return response;

  dumpObject(response?.objects?.[0]);

  return response;
};

const fetchNodes2 = async (api, collection, filter = {}, opts = {}) => {
  const response = await fetchCollection2(api, collection, filter, opts);

  if (response?.objects === undefined) return response;

  const objects = response.objects.map((object) => {
    return {
      ...object,
      assigned_vehicle: object.assigned_vehicle_id
        ? `/api/v2/node/${object.assigned_vehicle_id}`
        : null,
      booking: object.booking_id
        ? `/api/v2/booking/${object.booking_id}`
        : null,
      operations_location: object.operations_location_id
        ? `/api/v2/operations_location/${object.operations_location_id}`
        : null,
      resource_uri: object.id ? `/api/v2/node/${object.id}` : null,
      simulation: object.simulation_id
        ? `/api/v2/simulation/${object.simulation_id}`
        : null,
      transit_stop: object.transit_stop_id
        ? `/api/v2/transit_stop/${object.transit_stop_id}`
        : null,
    };
  });

  // dumpObject(response?.objects?.[0]);
  // dumpObject(objects[0]);

  return { ...response, objects };
};

const fetchBookings2 = async (api, collection, filter = {}, opts = {}) => {
  const response = await fetchCollection2(api, collection, filter, opts);

  if (response?.objects === undefined) return response;

  const objects = response.objects.map((object) => {
    return {
      ...object,
      project: object.project_id
        ? `/api/v2/project/${object.project_id}`
        : null,
      resource_uri: object.id ? `/api/v2/booking/${object.id}` : null,
      simulation: object.simulation_id
        ? `/api/v2/simulation/${object.simulation_id}`
        : null,
    };
  });

  // dumpObject(response?.objects?.[0]);
  // dumpObject(objects[0]);

  return { ...response, objects };
};

const fetchVehicle2 = async (api, collection, filter = {}, opts = {}) => {
  const response = await fetchCollection2(api, collection, filter, opts);

  if (response?.objects === undefined) return response;

  const objects = response.objects.map((object) => {
    return {
      ...object,
      routing_engine_settings: {
        ...object.routing_engine_settings,
        continue_straight: object.routing_engine_settings.continue_straight
          ? object.routing_engine_settings.continue_straight
          : 'default',
      },
      assignment: object.assignment_id
        ? `/api/v2/assignment/${object.assignment_id}`
        : null,
      driver: object.driver_id ? `/api/v2/driver/${object.driver_id}` : null,
      physical_vehicle: object.physical_vehicle_id
        ? `/api/v2/physical_vehicle/${object.physical_vehicle_id}`
        : null,
      project: object.project_id
        ? `/api/v2/project/${object.project_id}`
        : null,
      resource_uri: object.id ? `/api/v2/vehicle/${object.id}` : null,
      simulation: object.simulation_id
        ? `/api/v2/simulation/${object.simulation_id}`
        : null,
      vehicle_type: object.vehicle_type_id
        ? `/api/v2/vehicle_type/${object.vehicle_type_id}`
        : null,
    };
  });

  // dumpObject(response?.objects?.[0]);
  // dumpObject(objects[0]);

  return { ...response, objects };
};

const fetchProject2 = async (api, collection, filter = {}, opts = {}) => {
  const response = await fetchCollection2(api, collection, filter, opts);

  if (response?.objects === undefined) return response;

  const objects = response.objects.map((object) => {
    return {
      ...object,
      resource_uri: object.id ? `/api/v2/project/${object.id}` : null,
    };
  });

  // dumpObject(response?.objects?.[0]);
  // dumpObject(objects[0]);

  return { ...response, objects };
};

const fetchFunctionsMapping = {
  project: fetchObjects,
};

const fetchFunctionsMapping2 = {
  project: fetchProject2,
  vehicle: fetchVehicle2,
  booking: fetchBookings2,
  node: fetchNodes2,
  deletionlog: fetchCollection,
};

const fetchFunctions = fetchFunctionsMapping2;

const cache = { data: {}, serialNumbers: {} };

const getPersistentCollection = () => {};
const setPersistentCollection = () => {};
const removePersistentCollection = () => {};

// const getPersistentKey = (name, requestHash) => [name, 'v1', requestHash].join(':');

// const getPersistentCollection = (name, requestHash) => {
//   try {
//     const persistentKey = getPersistentKey(name, requestHash);

//     const collection = JSON.parse(global.localStorage.getItem(persistentKey));
//     cache.data[requestHash] = collection;

//     return collection;
//   } catch (error) {
//     // eslint-disable-next-line
//     console.log(error);
//   }
// };

// const setPersistentCollection = (name, requestHash, collection) => {
//   try {
//     const persistentKey = getPersistentKey(name, requestHash);

//     global.localStorage.setItem(persistentKey, JSON.stringify(collection));
//   } catch (error) {
//     // eslint-disable-next-line
//     console.log(error);
//   }

//   return collection;
// };

// const removePersistentCollection = (name, requestHash) => {
//   try {
//     const persistentKey = getPersistentKey(name, requestHash);

//     global.localStorage.removeItem(persistentKey);
//   } catch (error) {
//     // eslint-disable-next-line
//     console.log(error);
//   }
// };

const loadCollection = async (api, collection, filter = {}, opts = {}) =>
  D2.A.FUNCTION(
    'loadCollection',
    { api, collection, filter, opts },
    async ({ $D2 }) => {
      await sync();

      D2.S.INFO('loadCollection', { collection, filter });

      const { address, prefix } = api;

      const { forceReload = false } = opts;

      const requestIdentity = { address, prefix, collection, filter };
      const requestHash = md5(JSON.stringify(requestIdentity));

      const memoryCachedResponse = cache.data[requestHash];

      const cachedResponse = !forceReload
        ? memoryCachedResponse ??
          getPersistentCollection(collection, requestHash)
        : undefined;

      const cahcedSerialNumber = cache.serialNumbers[requestHash] ?? 1;
      const serialNumber = forceReload
        ? cahcedSerialNumber + 1
        : cahcedSerialNumber;
      cache.serialNumbers[requestHash] = serialNumber;

      const isLoadedFromCache = !!cachedResponse?.version_ts;

      const fetchFunction = fetchFunctions[collection] ?? fetchCollection;

      const originalCollection = isLoadedFromCache
        ? cachedResponse
        : await indexCollection(
            await fetchFunction(
              api,
              collection,
              {
                ...filter,
                // modified_at__gt: moment
                //   .unix(0)
                //   .tz('UTC')
                //   .format(),
                order_by: 'id',
              },
              opts
            ),
            opts
          );

      if (originalCollection.error) {
        return originalCollection;
      }

      await sync();

      const updatedCollection = originalCollection.version_ts
        ? await indexCollection(
            await fetchFunction(
              api,
              collection,
              {
                ...filter,
                modified_at__gt: originalCollection.version_ts,
                order_by: 'id',
              },
              opts
            ),
            opts
          )
        : { objects: {} };

      if (updatedCollection.error) {
        const { error } = updatedCollection;
        return { error };
      }

      const updatedObjects = Object.values(updatedCollection.objects);

      const isUpdated = updatedObjects.length && !!updatedCollection.version_ts;

      if (isUpdated) {
        updatedObjects.map((item) => {
          // eslint-disable-next-line
          console.log(`*** Updated ${collection}:`, item);
        });
      }

      const latestCollection = !isUpdated
        ? originalCollection
        : {
            objects: {
              ...originalCollection.objects,
              ...updatedCollection.objects,
            },
            index_by_id: {
              ...originalCollection.index_by_id,
              ...updatedCollection.index_by_id,
            },
            index_by_resource_uri: {
              ...originalCollection.index_by_resource_uri,
              ...updatedCollection.index_by_resource_uri,
            },
            version_ts: updatedCollection.version_ts,
          };

      const updateLatestCollection = (value) => {
        if (value.version_ts) {
          cache.data[requestHash] = value;
          setPersistentCollection(collection, requestHash, value);
          return value;
        }
        delete cache.data[requestHash];
        removePersistentCollection(collection, requestHash);
        return value;
      };

      if (isUpdated || !isLoadedFromCache) {
        updateLatestCollection(latestCollection);
      }

      const resultCollection = {
        original: originalCollection,
        updates: updatedCollection,
        updated: updatedCollection,
        latest: latestCollection,
        version: latestCollection.version_ts,
        serialNumber,
        requestHash,
        updateLatestCollection,
      };

      return resultCollection;
    }
  );

export default loadCollection;
